<template>
  <div class="container rounded-lg">
    <div class="flex items-center justify-between mb-[24px]">
      <h4 class="font-[600] text-[#222222] text-[16px] mb-0">
        Ringkasan
      </h4>
      <date-range-picker
        v-model="summaryPeriod"
        :locale-data="locale"
        :ranges="datePickerRangeGeneral"
        :opens="'left'"
        :date-format="createDatePickerRestrictor()"
        class="w-auto"
      >
        <template #input="picker">
          <div class="d-flex align-items-center justify-between w-100">
            <div class="mr-1">
              <span
                style="color: #c2c2c2 !important"
              >
                {{ getFormattedDateRange(picker.startDate, picker.endDate) }}
              </span>
            </div>
            <span class="k-arrow-down-1 text-[20px] font-semibold" />
          </div>
        </template>
      </date-range-picker>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
      <div class="bg-[#F4FBFF] border-[1px] rounded-lg p-[14px] border-[#E2E2E2] relative">
        <div class="overflow-hidden absolute top-0 right-0 bottom-0 w-[400px] z-0"><img
          class="absolute -top-[99px] -right-[55px]"
          src="https://storage.googleapis.com/komerce/icon/Logo-product.svg"
          alt="kompack"
        ></div>
        <div class="relative flex flex-col-reverse sm:flex-row sm:justify-between gap-10 z-[1]">
          <div class="w-full">
            <div class="flex items-center justify-between gap-[16px]">
              <div class="flex items-center gap-[8px] mb-[16px]">
                <div class="bg-[#DCF3EB] size-[28px] p-[4px] flex items-center justify-center rounded-lg">
                  <span class="k-usd-coin-usdc text-[16px] font-medium text-[#34A770]" />
                </div>
                <h3 class="mb-0 font-medium text-[16px] text-[#333333]">
                  Total Nilai Transaksi
                </h3>
              </div>
              <router-link
                :to="`/kompack/total-nilai-transaksi?start_date=${YEAR_MONTH_DAY(summaryPeriod.startDate)}&end_date=${YEAR_MONTH_DAY(summaryPeriod.endDate)}`"
                class="border-[1px] text-[12px] border-[#F95031] font-medium rounded py-[5px] px-[10px] flex items-center gap-2 hover:shadow"
              >Detail<span class="k-arrow-right-3 text-[18px] font-[600] ml-[10px]" />
              </router-link>
            </div>
            <div>
              <b-skeleton
                v-if="loadingSummary"
                class="mt-[8px] mb-[16px]"
                width="85%"
                height="38px"
              />
              <p
                v-else
                class="text-[36px] font-semibold text-[#333333] leading-[38px] mb-[16px] flex items-center gap-[8px] flex-wrap"
              >
                {{ summaryData.total_transaction_this_month | rupiah }} <span :class="[summaryData.percentage_of_total_income > 0 ? 'bg-[#34A770]' : 'bg-[#E31A1A]', 'text-white py-[7px] px-[4px] text-[12px] leading-[12px] rounded-lg font-normal']">{{ `${summaryData.percentage_of_total_income >= 0 ? '+' : '' }${summaryData.percentage_of_total_income}` }}%</span>
              </p>
            </div>
            <p class="text-[#626262] text-[10px]">
              Bulan lalu : {{ summaryData.total_transaction_last_month | rupiah }}
            </p>
          </div>
        </div>
        <div class="flex gap-[16px] flex-wrap z-[1] relative">
          <div class="border-[1px] border-[#E2E2E2] bg-white px-[14px] pt-[8px] pb-[16px] rounded-lg grow">
            <div class="flex gap-[10px] items-center mb-[8px]">
              <h3 class="mb-0 text-[12px] text-[#626262] font-normal">
                Penghasilan Mitra
              </h3>
            </div>
            <div>
              <b-skeleton
                v-if="loadingSummary"
                class="!mb-[6px]"
                width="85%"
                height="22px"
              />
              <p
                v-else
                class="text-[20px] font-semibold text-[#333333] leading-[20px] mb-[8px] flex items-center gap-[8px] flex-wrap"
              >
                {{ summaryData.mitra_earnings_this_month | rupiah }} <badge-light
                  :difference="summaryData.percentage_of_mitra_income"
                />
              </p>
            </div>
            <p class="text-[#828282] text-[10px] mb-0">
              Bulan lalu : <span class="text-[#333333]">{{ summaryData.mitra_earnings_last_month | rupiah }}</span>
            </p>
          </div>
          <div class="border-[1px] border-[#E2E2E2] bg-white px-[14px] pt-[8px] pb-[16px] rounded-lg grow">
            <div class="flex gap-[10px] items-center mb-[8px]">
              <h3 class="mb-0 text-[12px] text-[#626262] font-normal">
                Penghasilan Kompack
              </h3>
            </div>
            <div>
              <b-skeleton
                v-if="loadingSummary"
                class="!mb-[6px]"
                width="85%"
                height="22px"
              />
              <p
                v-else
                class="text-[20px] font-semibold text-[#333333] leading-[20px] mb-[8px] flex items-center gap-[8px] flex-wrap"
              >
                {{ summaryData.kompack_revenue_this_month | rupiah }} <badge-light :difference="summaryData.percentage_of_kompack_income" />
              </p>
            </div>
            <p class="text-[#828282] text-[10px] mb-0">
              Bulan lalu : <span class="text-[#333333]">{{ summaryData.kompack_revenue_last_month | rupiah }}</span>
            </p>
          </div>
        </div>
      </div>
      <CardTagihan
        :period="summaryPeriod"
      />
    </div>
  </div>
</template>

<script>
import {
  today, last30,
} from '@/store/helpers'
import {
  LABELDAY, LABELMONTH, YEAR_MONTH_DAY, createDatePickerRestrictor,
} from '@/libs/filterDate'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import BadgeLight from './BadgeLight.vue'
import { getFormattedDateRange } from '../helpers'
import CardTagihan from './CardTagihan.vue'
import { datePickerRangeGeneral } from '../config'

export default {
  components: {
    DateRangePicker,
    BadgeLight,
    CardTagihan,
  },
  data() {
    return {
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      loadingSummary: true,
      summaryData: {
        total_transaction_this_month: 0,
        total_transaction_last_month: 0,
        percentage_of_total_income: 0,
        mitra_earnings_this_month: 0,
        mitra_earnings_last_month: 0,
        percentage_of_mitra_income: 0,
        kompack_revenue_this_month: 0,
        kompack_revenue_last_month: 0,
        percentage_of_kompack_income: 0,
      },
      summaryPeriod: {
        startDate: this.$route.query.ss ? new Date(this.$route.query.ss) : last30,
        endDate: this.$route.query.se ? new Date(this.$route.query.se) : today,
      },
    }
  },
  watch: {
    summaryPeriod: {
      handler() {
        this.getSummaryData()
        this.updatePeriodQuery()
      },
    },
  },
  created() {
    this.getSummaryData()
    this.datePickerRangeGeneral = datePickerRangeGeneral(today)
  },
  methods: {
    getFormattedDateRange,
    YEAR_MONTH_DAY,
    createDatePickerRestrictor,
    /**
     * Update periode di URL query parameters untuk mempertahankan state saat reload
     */
    updatePeriodQuery() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ss: YEAR_MONTH_DAY(this.summaryPeriod.startDate),
          se: YEAR_MONTH_DAY(this.summaryPeriod.endDate),
        },
      })
    },
    /**
     * Fetches summary data from the API based on selected date range
     */
    getSummaryData() {
      this.loadingSummary = true
      const url = '/komship/api/v1/admin/transactions/fulfillment-summaries'
      const params = {
        start_date: YEAR_MONTH_DAY(this.summaryPeriod.startDate),
        end_date: YEAR_MONTH_DAY(this.summaryPeriod.endDate),
      }
      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          if (!data) {
            throw new Error('no data')
          }
          this.summaryData = data
          this.loadingSummary = false
        })
        .catch(err => {
          this.loadingSummary = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mendapatkan data ringkasan, silahkan coba lagi',
              variant: 'danger',
            },
          }, { timeout: 2000 })
          this.summaryData = {
            total_transaction_this_month: 0,
            total_transaction_last_month: 0,
            percentage_of_total_income: 0,
            mitra_earnings_this_month: 0,
            mitra_earnings_last_month: 0,
            percentage_of_mitra_income: 0,
            kompack_revenue_this_month: 0,
            kompack_revenue_last_month: 0,
            percentage_of_kompack_income: 0,
          }
        })
    },
  },
}
</script>

<style scoped>
.container {
    box-shadow: 2px 2px 12px 0px #00000014;
    background-color: #fff;
    margin-bottom: 16px;
    padding: 24px
};
</style>

<style>
.kompack-ringkasan-popover.popover.b-popover.bs-popover-top .arrow::before,
.kompack-ringkasan-popover.popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::before,
.kompack-ringkasan-popover.popover.b-popover.bs-popover-top .arrow::after,
.kompack-ringkasan-popover.popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #F95031;
}
</style>
